import { createFileRoute } from "@tanstack/react-router";
import { HelpHub } from "../admin/help";

export const Route = createFileRoute("/student/help")({ component: () => <HelpHub portal="student" /> });
